import axios from "axios";
import { newAbortSignal } from "../../utils";
import { SessionStore } from "../../types/store/SessionStore";
import { AuditQuery } from "../../types/model/app/AuditQuery"
import { AuditResponse } from "../../types/interfaces/app/AuditResponse";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/app/admin/audit`;

export const getAudit = async (filters: AuditQuery): Promise<AuditResponse> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}"
  );

  const queryParams = new URLSearchParams();

  if (filters.tableName) queryParams.append("tableName", filters.tableName);
  if (filters.operationType) queryParams.append("operationType", filters.operationType);
  if (filters.accountId) queryParams.append("accountId", filters.accountId.toString());
  if (filters.userId) queryParams.append("userId", filters.userId.toString());
  if (filters.userName) queryParams.append("userName", filters.userName);
  if (filters.startDate) queryParams.append("startDate", filters.startDate.toISOString());
  if (filters.endDate) queryParams.append("endDate", filters.endDate.toISOString());
  if (filters.numRecords) queryParams.append("numRecords", filters.numRecords.toString());
  if (filters.offset) queryParams.append("offset", filters.offset.toString());

  const finalURL = `${BASE_URL}?${queryParams.toString()}`;

  return await axios
    .get<any>(finalURL, {
      headers: {
        "content-type": "application/json",
        "x-access-token": session?.accessToken,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`))
          : AbortSignal.timeout(
              Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)
            ),
    })
    .then((response) => {
      return {
        audit: response.data,
        total: Number.parseInt(response.headers["x-total-count"] || "0", 10),
      };
    });
};